import { Helmet } from 'react-helmet-async';
import CommonHeader from '../components/Headers/CommonHeader';
import { searchContext, userAppContext } from '../context/Context';
import LoadingSpinner from '../global/Loader/LoaderSpinner';
import AdvancedSearchContainer from '@/components/AdvancedSearch/AdvancedSearchContainer';
import RestrictedAccess from '@/components/Modal/RestrictedAccess';

export default function AdvancedSearchPage() {
  const { isAuthenticated } = userAppContext();
  const { loading, error } = searchContext();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="error-message">An error occurred: {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>DISGENET: Advanced Search</title>
        <meta name="description" content="Advanced search tools for DISGENET." />
      </Helmet>
      <CommonHeader />
      <div className="p-4 advanced-research container-view">
        <div className="search-results-container">
          {isAuthenticated ? (
            <AdvancedSearchContainer />
          ) : (
            <RestrictedAccess feature="advancedSearch">
              <AdvancedSearchContainer />
            </RestrictedAccess>
          )}
        </div>
      </div>
    </>
  );
}
